module.exports = "/_next/static/images/truck6-9fbcc9244842fed73c660854ef543627.png.webp";